import type { ReactElement } from 'react';
import { AbsoluteFill, useVideoConfig } from 'remotion';

// Components
import { Confetti as ConfettiAnimation } from '@/components/common/ConfettiAnimation';

// Constants
import { DEFAULT_CONFETTI_COLORS } from '@/components/common/ConfettiAnimation/constants';
import { CONFETTI_CONFIG_SCENE8 } from '../constants';

interface ConfettiScene8Props {
  startFrame: number;
}

/**
 * Confetti effect for Scene 8 with multiple burst locations.
 * Uses blended grayscale colors to match the scene's color palette.
 */
export const ConfettiScene8 = ({
  startFrame,
}: ConfettiScene8Props): ReactElement => {
  const { width, height } = useVideoConfig();

  const {
    PARTICLES_PER_BURST,
    ANGLE,
    SPREAD,
    TICKS,
    GRAVITY,
    SCALAR,
    DRIFT,
    START_VELOCITY,
    DECAY,
    SHAPES,
    Z_INDEX,
    BURST_LOCATIONS,
  } = CONFETTI_CONFIG_SCENE8;

  return (
    <AbsoluteFill className="pointer-events-none" style={{ zIndex: Z_INDEX }}>
      {BURST_LOCATIONS.map(({ x, ratio }, index) => (
        <ConfettiAnimation
          key={index}
          fireAtFrame={startFrame}
          x={width * x}
          y={0}
          width={width}
          height={height}
          particleCount={Math.floor(PARTICLES_PER_BURST * ratio)}
          angle={ANGLE}
          spread={SPREAD}
          ticks={TICKS}
          gravity={GRAVITY}
          scalar={SCALAR}
          drift={DRIFT}
          startVelocity={START_VELOCITY}
          decay={DECAY}
          colors={DEFAULT_CONFETTI_COLORS}
          shapes={SHAPES}
        />
      ))}
    </AbsoluteFill>
  );
};
